export default "__VITE_ASSET__pcBs8Wgf__"